module.exports = __webpack_public_path__ + "static/img/huangdi1.5cfd4336.jpg";